import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ballbyball',
  templateUrl: './ballbyball.component.html',
  styleUrls: ['./ballbyball.component.scss'],
})
export class BallbyballComponent implements OnInit {
  title = 'app-ballbyball';

  ngOnInit(): void {}
}
